import { isNewPostsNotificationDetails } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { $t } from "@/lib/i18nHelpers";
import { getProfileUrl } from "@/lib/urlHelpers";
import router from "@/router";
import { NotificationData } from "@/types";

export default function(notification: Notification): NotificationData | false {
  const details = notification.details;
  const user = notification.user;

  if (notification.type === NotificationType.NEW_POSTS && user) {
    return {
      text: $t("{0} has published a new post", [user.screenName]),
      position: "top",
      timeout: 7000,
      image: {
        user,
        post: isNewPostsNotificationDetails(details) ? details.post : undefined,
      },
      onNotificationClick: () =>
        router.push(
          getProfileUrl(user, {
            feedId: isNewPostsNotificationDetails(details) ? details.postId : undefined,
          })
        ),
    };
  }
  return false;
}
